import { EstateComplexLevel } from "@1games-ru/region-shared/dist/enums/estate/estate";
import { PropsWithChildren } from "react";
import { cn } from "@/core/helpers/cn";
import eliteButtonLarge from "@/domains/estate/components/elevator/res/button-elite-lg@2x.png";
import eliteButton from "@/domains/estate/components/elevator/res/button-elite@2x.png";
import modernButtonActive from "@/domains/estate/components/elevator/res/button-modern-active@2x.png";
import modernButton from "@/domains/estate/components/elevator/res/button-modern@2x.png";
import simpleButtonActive from "@/domains/estate/components/elevator/res/button-simple-active@2x.png";
import simpleButton from "@/domains/estate/components/elevator/res/button-simple@2x.png";

const variants = {
  [EstateComplexLevel.Economy]: {
    md: {
      sprite: simpleButton,
      spriteActive: simpleButtonActive,
      size: { width: 52, height: 52 },
      activeClassName: "shadow-[0_0_40px_rgba(255,22,22,0.6),inset_0_0_12px_#ff6767] filter-none",
    },
    lg: {
      sprite: simpleButton,
      spriteActive: simpleButtonActive,
      size: { width: 58, height: 58 },
      activeClassName: "shadow-[0_0_40px_rgba(255,22,22,0.6),inset_0_0_12px_#ff6767] filter-none",
    },
  },
  [EstateComplexLevel.Standard]: {
    md: {
      sprite: modernButton,
      spriteActive: modernButtonActive,
      size: { width: 110, height: 62 },
      activeClassName: "text-[#ff4e4e]",
    },
  },
  [EstateComplexLevel.Business]: {
    md: {
      sprite: eliteButton,
      spriteActive: eliteButton,
      size: { width: 60, height: 60 },
      activeClassName: "text-[#ff4e4e] filter-none",
    },
    lg: {
      sprite: eliteButtonLarge,
      spriteActive: eliteButtonLarge,
      size: { width: 93, height: 60 },
      activeClassName: "text-[#ff4e4e] filter-none",
    },
  },
};

export function ElevatorButton({
  variant,
  size: buttonSize = "md",
  isActive = false,
  children,
  onClick,
  className,
}: PropsWithChildren<{
  variant: EstateComplexLevel;
  size?: "md" | "lg";
  isActive?: boolean;
  onClick?: () => void;
  className?: string;
}>) {
  const { sprite, spriteActive, size, activeClassName } = variants[variant][buttonSize];
  const src = isActive ? spriteActive : sprite;

  return (
    <button
      type="button"
      className={cn(
        "relative shrink-0 rounded-full flex items-center justify-center",
        variant === EstateComplexLevel.Economy && "text-2xl text-white font-medium",
        variant === EstateComplexLevel.Business && "text-2xl text-[#323232] font-medium",
        isActive && activeClassName,
        className,
      )}
      style={size}
      onClick={onClick}
    >
      <img src={src} alt="button" className="absolute top-0 left-0 size-full pointer-events-none" />
      <div
        className={cn(
          "relative w-[4ch] text-2xl font-medium flex items-center justify-center",
          variant === EstateComplexLevel.Standard && "-right-[22px]",
          variant === EstateComplexLevel.Business && "text-3xl",
        )}
      >
        {children}
      </div>
    </button>
  );
}
